import { upsertEntity } from "actions/entities";
import { createEntityWithDefaults } from "actions/entities";
import { createEntity, destroyEntity, fetchEntities } from 'actions/entities';
import ConsultationTypeForm from 'components/consultation_types/ConsultationTypeForm'
import ConsultationTypesListItem from 'components/consultation_types/ConsultationTypesListItem'
import EntitiesList from 'components/entities/EntitiesList';
import { connect } from 'react-redux'

import { getConsultationTypes } from 'selectors/consultation_types'
import { Card } from 'semantic-ui-react'


const mapStateToProps = (state, ownProps) => {
  return {
    entities: getConsultationTypes(state,ownProps),
    entityName: 'consultationType',
    item: ConsultationTypesListItem,
    form: ConsultationTypeForm,
    listComponent: Card.Group,
    loading: state.meta.consultationType.loading,
    error: state.meta.consultationType.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultationTypes'))
    },
    upsertEntity: (entityId) => {
      dispatch(upsertEntity('consultationType', entityId))
    },
    createEntity: () => {
      dispatch(createEntity('consultationType'))
    },
    createEntityWithDefaults: () => {
      return dispatch(createEntityWithDefaults('consultationType', { duration: "1:00", icon: 'talk' }))
    },
    destroyEntity: (consultationType) => {
      dispatch(destroyEntity('consultationType', consultationType.id))
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
